var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocWhiteDwdw(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.29 12.572h4.847a.677.677 0 0 0 .669-.675.669.669 0 0 0-.669-.666H6.29a.669.669 0 0 0-.669.666c0 .369.303.675.669.675zm3.012-4.276H6.29a.677.677 0 0 0-.669.675c0 .369.303.666.669.666h3.012a.669.669 0 0 0 .668-.666.677.677 0 0 0-.668-.675zm6.359-1.973c.209-.002.437-.005.644-.005.223 0 .401.18.401.405v7.236c0 2.232-1.79 4.041-4 4.041H5.611c-2.317 0-4.206-1.899-4.206-4.239V4.059C1.406 1.827 3.206 0 5.426 0h4.758a.41.41 0 0 1 .41.414v2.898c0 1.647 1.345 2.997 2.976 3.006.38 0 .716.003 1.01.005.229.002.432.004.611.004.127 0 .292-.002.47-.004zm.245-1.314c-.732.003-1.596 0-2.217-.006-.986 0-1.797-.82-1.797-1.815V.815c0-.388.466-.58.732-.3l1.804 1.895 1.784 1.873a.43.43 0 0 1-.306.726z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocWhiteDwdw);
export default __webpack_public_path__ + "static/media/doc_white_dwdw.24dfacfd6e3d59d184a7db5636775311.svg";
export { ForwardRef as ReactComponent };